import React, { PropsWithChildren } from 'react';
import { Link, Gap, Icon, IconOfKind } from '@common/components';
import { Menu } from 'antd';

const fixAntd = { paddingLeft: 0 };

export const Item = ({
  to,
  icon,
  children,
  ...other
}: PropsWithChildren<{ to: string; icon: IconOfKind }>) => (
  <>
    <Link className="SidenavItem" to={to}>
      <Menu.Item {...other} style={fixAntd}>
        <Gap vertical align="center" size="xs">
          <Icon {...icon} className="works-menu-icon" size="lg" />
          <div className="works-menu-text">{children}</div>
        </Gap>
      </Menu.Item>
    </Link>
    <style jsx global>{`
      .SidenavItem li.ant-menu-item {
        height: 72px;
        padding-right: 0;
        margin-bottom: 0;
        margin-top: 0;
      }

      .SidenavItem li.ant-menu-item .ant-menu-title-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 11px;
        line-height: 16px;
      }
    `}</style>
  </>
);
